








import { VueCustom, CustomVueType, CustomVueConstructor } from 'vue-custom';
import { getStyle } from 'utils';
import EventsManager from 'managers/events.manager';

import Box from 'components/base-box.vue';

type ComponentCustom = {
  $refs: {
    box: CustomVueType,
  },
};
export default (VueCustom as CustomVueConstructor<ComponentCustom>).extend({
  name: 'workspace-box-sizing',
  components: {
    Box,
  },
  data: () => ({
    obtainSize: true,
  }),
  computed: {
    boxData() {
      return {
        id: '0',
        elementId: '0',
        position: { x: -200, y: -200 },
      };
    },
  },
  mounted() {
    this.updateSize();
    EventsManager.onResize(() => {
      this.obtainSize = true;
      this.$nextTick(() => this.updateSize());
    });
  },
  methods: {
    updateSize(isRetry = false) {
      if (!this.$refs.box || !this.$refs.box.$el) {
        this.retry(isRetry);
        return;
      }

      const { width, height } = this.getSize();
      if (!width || !height) {
        this.retry(isRetry);
        return;
      }

      this.obtainSize = false;
      this.notify(width, height);
    },
    retry(isRetry: boolean) {
      if (isRetry) {
        this.notify(0, 0);
        return;
      }

      window.setTimeout(() => this.updateSize(true), 100);
    },
    getSize() {
      const styles = getStyle(this.$refs.box.$el);
      const width = parseInt(styles.width, 10) || 0;
      const height = parseInt(styles.height, 10) || 0;
      return {
        width,
        height,
      };
    },
    notify(width: number, height: number) {
      this.$store.dispatch('dimensionsWorkspaceBox', { width, height });
    },
  },
});
